const SET_CONTEXT = (state, ctx) => {
  state.context = ctx
}

export default { SET_CONTEXT }
